import moment from "moment"
const monthChange = (date, monthStep) => {
  return new Date(date.setMonth(date.getMonth() + monthStep));
}

function formatDate(dateTimeString) {
  return new Date(Date.parse(dateTimeString)).toLocaleString()
}

const getMonth = (inputDate) => {
  return inputDate.toLocaleString('default', { month: 'long' });
}

const getYear = (inputDate) => {
  return inputDate.getFullYear();
}

const getHourAndMinutes = (inputDate) => {
  let time = new Date(Date.parse(inputDate)).getHours() + ":" + new Date(Date.parse(inputDate)).getMinutes();
  return time
}

const getDay = (inputDate) => {
  const day = new Date(Date.parse(inputDate)).getDay();
  let day_in_string;
  if (day === 1)
    day_in_string = "Monday"
  else if (day === 2)
    day_in_string = "Tuesday"
  else if (day === 3)
    day_in_string = "Wednesday"
  else if (day === 4)
    day_in_string = "Thursday"
  else if (day === 5)
    day_in_string = "Friday"
  else if (day === 6)
    day_in_string = "Saturday"
  else if (day === 7)
    day_in_string = "Sunday"

  return day_in_string;
}

function formatDateTime(inputDate) {
  let mlist = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  let date = new Date(Date.parse(inputDate)).getDate() + "/" + mlist[new Date(Date.parse(inputDate)).getMonth()] + "/" + new Date(Date.parse(inputDate)).getFullYear();
  return date;
}


function formatDateForInputField(dateTimeString) {
  return moment.utc(dateTimeString).format('YYYY-MM-DD[T]HH:mm:ss')
}

function getTimeZoneAwareDateTime(dateTimeString) {
  let timedifference = new Date().getTimezoneOffset();
  return moment.utc(dateTimeString).utcOffset(timedifference).toISOString()
}

function getDifferenceInHours(a, b) {
  a = Date.parse(a)
  b = Date.parse(b)
  return (b - a) / 1000 / 60 / 60
}

export const DateTimeHelper = {
  formatDate,
  getDifferenceInHours,
  formatDateForInputField,
  formatDateTime,
  monthChange,
  getMonth,
  getYear,
  getDay,
  getHourAndMinutes,
  getTimeZoneAwareDateTime
};
